import { render, staticRenderFns } from "./AtePlatDevice.vue?vue&type=template&id=2fcf8f67"
import script from "./AtePlatDevice.vue?vue&type=script&lang=js"
export * from "./AtePlatDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports